import Vue from 'vue';
import 'swiper/swiper-bundle.min.css';

import Swiper from 'swiper/swiper-bundle.min';

Vue.prototype.$swiper = Swiper;
